import { useNavigate } from 'react-router-dom'
import { ArrowLeft } from 'lucide-react'
import { smartBack } from '../utils/navigation'

// Small pieces shared by the simplified list and detail pages (Sales first,
// then the other sections): a back link, a document header, status badges
// and status filter chips.

/** "← Invoices": goes back in history, or to `to` on a fresh load. */
export function BackLink({ to, label }) {
  const nav = useNavigate()
  return (
    <button type="button" className="back-link" onClick={() => smartBack(nav, to)}>
      <ArrowLeft size={15} aria-hidden="true" />
      {label}
    </button>
  )
}

/** Title row of a single sale, invoice, quote or refund. */
export function DocHeader({ back, title, badge, meta, actions }) {
  return (
    <header className="doc-header">
      {back}
      <div className="doc-header-row">
        <div className="doc-header-text">
          <div className="doc-header-title">
            <h1>{title}</h1>
            {badge}
          </div>
          {meta && <p className="doc-header-meta">{meta}</p>}
        </div>
        {actions && <div className="doc-header-actions">{actions}</div>}
      </div>
    </header>
  )
}

const TONES = {
  posted: 'good', completed: 'good', paid: 'good', sent: 'info', converted: 'good',
  'partially paid': 'info', unpaid: 'info',
  draft: 'muted',
  overdue: 'warn', expired: 'warn',
  void: 'bad', voided: 'bad', refunded: 'bad', refund: 'bad',
}

export function StatusBadge({ status, label, tone }) {
  const key = String(status || '').trim().toLowerCase()
  return <span className={`status-badge tone-${tone || TONES[key] || 'muted'}`}>{label || status || 'Draft'}</span>
}

/** Status filters as chips with counts: [{ id, label, count }]. */
export function FilterChips({ options, value, onChange, label = 'Show' }) {
  return (
    <div className="filter-chips" role="group" aria-label={label}>
      {options.map((o) => (
        <button
          key={o.id}
          type="button"
          className={`filter-chip${o.id === value ? ' active' : ''}`}
          aria-pressed={o.id === value}
          onClick={() => onChange(o.id)}
        >
          {o.label}
          {o.count != null && <span className="filter-chip-count">{o.count}</span>}
        </button>
      ))}
    </div>
  )
}
